export const app = { getPath: () => '/tmp' };
export const ipcRenderer = { send: () => {}, invoke: async () => null, on: () => {}, removeListener: () => {} };
export const BrowserWindow = class {};
export default { app, ipcRenderer, BrowserWindow };
